// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
